import React from 'react';
import { ShieldCheck } from 'lucide-react';

const ExplicitHeroHeader = () => {
  return (
    <section className="mb-10" data-testid="explicit-hero-header">
      <div className="max-w-3xl mx-auto mb-6">
        <p className="text-[11px] font-bold uppercase tracking-wider text-yellow-400 mb-2">
          Exclusive to Outlaw Media
        </p>

        <h1 className="text-3xl md:text-4xl font-black text-white leading-tight tracking-tight mb-3">
          Uncensored. <span className="text-red-500">Unfiltered.</span>
        </h1>
        <p className="text-sm md:text-base text-gray-400 leading-relaxed max-w-2xl">
          The content below is exclusive to Outlaw Media and is as uncensored as we can
          legally post. You won&apos;t see this footage on the mainstream news.
        </p>
      </div>

      {/* Privacy notice - subtle, editorial */}
      <div
        className="max-w-2xl bg-zinc-900/50 border border-zinc-800 rounded-md px-4 py-3 flex items-start gap-3"
        data-testid="explicit-privacy-notice"
      >
        <ShieldCheck className="h-4 w-4 text-emerald-500 flex-shrink-0 mt-0.5" />
        <p className="text-xs md:text-sm text-gray-400 leading-relaxed">
          <span className="text-emerald-400 font-bold">Your privacy is protected.</span>{' '}
          No personal information is stored when you like or comment on a video.
        </p>
      </div>
    </section>
  );
};

export default ExplicitHeroHeader;
